import Vue from 'vue';

import {
  get, post, put, del,
} from '@/request';

const state = () => ({
  group: null,
  groupPage: null,
  error: null,
});

const getters = {

};

const mutations = {
  error(s, e) {
    Vue.set(s, 'error', e);
  },
  setGroup(s, group) {
    Vue.set(s, 'group', group);
  },
  setGroupPage(s, groupPage) {
    Vue.set(s, 'groupPage', groupPage);
  },
};

const actions = {
  async createGroup({ commit }, form) {
    commit('error', null);
    try {
      const group = await post('/merchant/influencer_groups/', form, { commit });
      commit('setGroup', group);
    } catch (e) {
      commit('error', e);
    }
  },
  async getGroup({ commit }, id) {
    commit('error', null);
    try {
      const group = await get(`/merchant/influencer_groups/${id}?page_number=1&page_size=20`, { commit });
      commit('setGroup', group);
    } catch (e) {
      commit('error', e);
    }
  },
  async getGroupPage({ commit }, form) {
    commit('error', null);
    try {
      const group = await get(`/merchant/influencer_groups/${form.id}?page_number=${form.page}&page_size=20`, { commit });
      commit('setGroupPage', group);
    } catch (e) {
      commit('error', e);
    }
  },
  async updateGroup({ commit }, data) {
    commit('error', null);
    try {
      const group = await put(`/merchant/influencer_groups/${data.id}`, data.form, { commit });
      commit('setGroup', group);
    } catch (e) {
      commit('error', e);
    }
  },
  async regenerateCode({ commit }, data) {
    commit('error', null);
    try {
      const group = await put(`/merchant/influencer_groups/${data.id}/replace_code/`, null, { commit });
      commit('setGroup', group);
    } catch (e) {
      commit('error', e);
    }
  },
  async deleteInfluencerFromGroup({ commit }, data) {
    commit('error', null);
    try {
      await del(`/merchant/influencer_groups/${data.id}/influencers/${data.influencer_id}`, { commit });
    } catch (e) {
      console.error(e);
      commit('error', e);
    }
  },
  async deleteGroup({ commit }, id) {
    commit('error', null);
    try {
      const data = await del(`/merchant/influencer_groups/${id}`, { commit });
      console.debug(data);
      // commit('setGroup', data);
    } catch (e) {
      commit('error', e);
    }
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
